import { z, isoZ } from 'my-zod'

export const OutfitterInvoiceStatusEnum = z.enum(['Forecasted', 'Pending', 'Finalized'])

export const OutfitterInvoiceLineTypeEnum = z.enum(['RideFee', 'ProgramFee', 'Fee', 'Discount', 'Addon'])

export const outfitterInvoicesSystemView = z.object({
  id: z.string().uuid(),
  outfitterId: z.number().nullish(),
  status: OutfitterInvoiceStatusEnum,
  billingPeriod: isoZ.yearMonth(),
  date: isoZ.date(),
  dueDate: isoZ.date(),
  lines: z
    .object({
      id: z.string().uuid(),
      quoteId: z.number(),
      title: z.string(),
      description: z.string(),
      date: z.object({
        startDate: isoZ.date(),
        endDate: isoZ.date()
      }),
      type: z.enum(['RideFee', 'ProgramFee', 'Fee', 'Discount', 'Addon']),
      qty: z.number(),
      unitPrice: z.number(),
      total: z.number()
    })
    .array(),
  subtotal: z.number()
})

export type outfitterInvoicesSystemView = z.infer<typeof outfitterInvoicesSystemView>

export const outfitterInvoicesModel = z.object({
  id: z.string().uuid(),
  outfitterId: z.number().nullish(),
  status: OutfitterInvoiceStatusEnum,
  billingPeriod: isoZ.date(),
  date: isoZ.date(),
  dueDate: isoZ.date(),
  subtotal: z.number()
})

export const outfitterInvoiceLines = z
  .object({
    id: z.string().uuid(),
    invoiceId: z.string().uuid().nullable(),
    quoteId: z.number(),
    title: z.string(),
    description: z.string(),
    startDate: z.string(),
    endDate: z.string(),
    type: z.enum(['RideFee', 'ProgramFee', 'Fee', 'Discount', 'Addon']),
    qty: z.number(),
    unitPrice: z.number(),
    total: z.number()
  })
  .array()

export type outfitterInvoicesModel = z.infer<typeof outfitterInvoicesModel>
export type outfitterInvoiceLines = z.infer<typeof outfitterInvoiceLines>
